//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ["btnList"],
  components: {},
  data() {
    return {};
  },

  methods: {
    cbtn(item) {
      
      if (item.flage == "callback") {
        this.$router.go(-1);
      }

      if (item.flage == "close") {
        window.open("");
      }
      if (item.url) {
        if(item.required=="true"){
          this.$msg.alert("请选择必填项");
        }else{
          this.$router.push(item.url);
        }
      } else {
        return null;
      }
    }
  },

  created() {},

  mounted() {}
};
